export default "__VITE_ASSET__CqhrX9HC__"